<template>
  <vx-card title="Причины завершения обращений">
    <div slot="no-body" v-if="sum > 0">
      <vue-apex-charts
        class="mt-6 mb-8"
        type="donut"
        height="325"
        :series="series"
        :options="options"/>
    </div>

    <div v-else>Нет данных</div>

    <ul class="mt-6">
      <li v-for="(reason, index) in reasons" :key="index" class="flex items-center mb-3" v-if="reason.count > 0">
        <div class="mr-2">
          <div class="w-5 h-5 rounded-full" :style="{background: `${reason.color}`}"></div>
        </div>
        <div class="mr-2 whitespace-no-wrap">
          <span class="font-semibold">{{ reason.label }}</span> — {{ reason.count }}
        </div>
        <div class="ml-auto">
          <span class="mr-1">{{ calculatePercent(reason.count) }}%</span>
        </div>
      </li>
    </ul>
  </vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  props: {
    exit_reasons: {
      required: true,
      type: Object
    }
  },

  components: {
    VueApexCharts
  },

  data () {
    return {
      reasons: [
        {
          label: 'Клиент сам закрыл обращение',
          count: this.exit_reasons.client_close_count || 0,
          color: '#7470e9'
        },
        {
          label: 'Бездействие клиента',
          count: this.exit_reasons.client_inactivity_count || 0,
          color: '#41d8c6'
        },
        {
          label: 'Оператор закрыл обращение',
          count: this.exit_reasons.operator_close_count || 0,
          color: '#f8a94e'
        },
        {
          label: 'Бездействие оператора',
          count: this.exit_reasons.operator_inactivity_count || 0,
          color: '#669933'
        }
      ],

      sum: 0,

      options: {
        labels: [],
        colors: [],
        dataLabels: {
          enabled: true,
          dropShadow: {
            enabled: false
          }
        },
        legend: {
          show: false
        },
        chart: {
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: 0
        }
      },

      series: []
    }
  },

  created () {
    this.options.labels = this.reasons.map(reason => reason.label)
    this.options.colors = this.reasons.map(reason => reason.color)
    this.series = this.reasons.map(reason => reason.count)
    this.sum = this.reasons.reduce((sum, reason) => sum + reason.count, 0)
  },

  methods: {
    calculatePercent (a) {
      return this.sum > 0 ? Math.round((a * 100 / this.sum) * 10) / 10 : 0
    }
  }
}
</script>
